/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { getChannelListener } from './ChannelListener';
import Spinner from './Spinner';
import { useConnectionStore } from './stores/connectionStore';

export default function ConnectionBanner() {
  const connectionStatus = useConnectionStore((state) => state.status);

  if (connectionStatus === 'connected' || connectionStatus === 'initial') {
    return null;
  }

  const isConnecting = connectionStatus === 'connecting';

  const handleRetry = () => {
    getChannelListener().retry();
  };

  return (
    <div css={styles.banner}>
      <div css={styles.content}>
        <div css={styles.statusContainer}>
          {isConnecting && (
            <Spinner
              size={10}
              borderWidth={2}
              color="white"
              trackColor="rgba(255, 255, 255, 0.3)"
            />
          )}
          <span css={styles.text}>
            {isConnecting
              ? 'Reconnecting to server...'
              : 'Websocket connection lost'}
          </span>
        </div>
        <button
          css={styles.retryButton}
          onClick={handleRetry}
          disabled={isConnecting}
        >
          {isConnecting ? 'Connecting...' : 'Retry'}
        </button>
      </div>
    </div>
  );
}

const styles = {
  banner: css({
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    backgroundColor: 'rgb(180, 60, 50)',
    color: 'white',
    zIndex: 10000,
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.3)',
  }),
  content: css({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 16,
    padding: '4px',
    maxWidth: 1200,
    margin: '0 auto',
  }),
  statusContainer: css({
    display: 'flex',
    alignItems: 'center',
    gap: 10,
  }),
  text: css({
    fontSize: 12,
    fontWeight: 500,
  }),
  retryButton: css({
    padding: '2px 8px',
    fontSize: 8,
    fontWeight: 600,
    backgroundColor: 'white',
    color: 'rgb(180, 60, 50)',
    border: 'none',
    borderRadius: 4,
    cursor: 'pointer',
    transition: 'all 0.15s ease',
    '&:hover:not(:disabled)': {
      backgroundColor: 'rgb(240, 240, 240)',
    },
    '&:active:not(:disabled)': {
      backgroundColor: 'rgb(220, 220, 220)',
    },
    '&:disabled': {
      backgroundColor: 'rgba(255, 255, 255, 0.5)',
      cursor: 'not-allowed',
    },
  }),
};
